<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col sm="12">
          <b-button variant="link" @click="go_list()" class="float-right px-0">Quick Guide Exit</b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <!-- progress bar -->
        <b-col sm="1"></b-col>
        <b-col sm="10">
          <p>
            <StepProgress active-color="skyblue" :steps="steps" :current-step="status.step"/>
          </p>
        </b-col>
        <b-col sm="1"></b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col sm="12">
          <center>
            <h1>
              {{steps[status.step]}}
            </h1>
          </center>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col sm="12">
          <transition-group name="slide-fade">
            <!-- first -->
            <b-form-group v-if="status.step == 0" v-bind:key="0">
              <b-input-group class="text-center" v-b-tooltip.hover.hover title="www.f1security.co.kr, img.f1security.co.kr, ftp.f1security.co.kr => FQDN is f1security.co.kr">
                <b-input-group-prepend>
                  <b-input-group-text>
                    FQDN &nbsp; <i style="cursor:pointer" class="fa fa-question-circle"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input class="text-center border" type="text" ref="fqdn" id="ph_fqdn" placeholder="FQDN (ex : company.com)" v-model="model.fqdn" @keypress.enter="next()"></b-form-input>
                <b-input-group-append is-text>
                  <b-form-checkbox switch class="mr-n2 mb-n1" v-model="model.is_https">
                    USE HTTPS
                  </b-form-checkbox>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <!-- seconed -->
            <!-- // TODO : 정책이 있을 경우에 대해서 정책을 설정할 수 있도록 해야 함 -->
            <b-form-group v-if="status.step == 1" v-bind:key="1">
              <center>
                <h4>Create New Policy for Scanning</h4>
                <small>
                  This step Automatically generates "Quick scanning" policy,
                  later you can configure a new policy or this policy edit, remove can do it
                </small>
                <hr>
                <b-card class="text-center">
                  <div slot="header">
                    <center>
                      <strong>Policy : {{policy_description}}</strong>
                    </center>
                    <hr>
                    <b-button v-if="policy_has" variant="link" @click="modal_policy= true" class="float-right px-0">Using existing policy</b-button>
                  </div>
                    <b-row>
                      <b-col md="12">
                        <b-form-group v-b-tooltip.hover.hover :title="`Enter whether to check by moving (path) the link from the first page to the next. The default value for Quick Setup is ${policy.depth}`">
                            <b-input-group-prepend><b-input-group-text> Maximum path depth &nbsp; <i style="cursor:pointer" class="fa fa-question-circle"></i> </b-input-group-text></b-input-group-prepend>
                            <b-form-input :disabled="true" class="text-center border" type="number" id="ph_depth" :min="1" :max="100" v-model="policy.depth" :plaintext="true"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <b-form-group
                          v-b-tooltip.hover.hover
                          :title="`
                          Enter the maximum sublink to navigate within a page.
                          Ignore any excess links.
                          Normally if too many links exist on one page, you can reach the maximum navigation page before navigating to the other to prevent it from not being checked in a balanced way.
                          The default value for Quick Setup is ${policy.links}`"
                        >
                            <b-input-group-prepend><b-input-group-text> Sub Page Link &nbsp; <i style="cursor:pointer" class="fa fa-question-circle"></i> </b-input-group-text></b-input-group-prepend>
                            <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="1" :max="1000" v-model="policy.links" :plaintext="true"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <b-form-group
                          v-b-tooltip.hover.hover
                          :title="`
                          Total number of pages to check on the inspection site.
                          End the check when the entered number is reached.
                          can be specified within the range of 1 to license limit.
                          The default value for Quick Setup is ${policy.limit}`"
                        >
                            <b-input-group-prepend><b-input-group-text> Maximum Navigation Page &nbsp; <i style="cursor:pointer" class="fa fa-question-circle"></i> </b-input-group-text></b-input-group-prepend>
                            <b-form-input :disabled="true" class="text-center border" type="number" id="ph_limit" :min="10" :max="50000" v-model="policy.limit" :plaintext="true"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <b-form-group
                          v-b-tooltip.hover.hover
                          :title="`
                          Time to wait for page loading.
                          can be specified within the range of 1-30.
                          The default value for Quick Setup is ${policy.timeout}`"
                        >
                            <b-input-group-prepend><b-input-group-text> TimeOut(Seceond) &nbsp; <i style="cursor:pointer" class="fa fa-question-circle"></i> </b-input-group-text></b-input-group-prepend>
                            <b-form-input :disabled="true" class="text-center border" type="number" id="ph_timeout" :min="1" :max="30" v-model="policy.timeout" :plaintext="true"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <b-form-group
                          v-b-tooltip.hover.hover
                          :title="`
                          Time to wait before moving to a new page.
                          can be specified within the range of 1 to 10 000.
                          The default value for Quick Setup is ${policy.delay}`"
                        >
                            <b-input-group-prepend><b-input-group-text> Check Speed(Millisecond) &nbsp; <i style="cursor:pointer" class="fa fa-question-circle"></i> </b-input-group-text></b-input-group-prepend>
                            <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="0" :max="10000" v-model="policy.delay" :plaintext="true"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                </b-card>
              </center>
            </b-form-group>
            <!-- final -->
            <b-form-group v-if="status.step == 2" v-bind:key="2">
              <center>
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center text-danger">
                    * Charging will begin when the first site registration is made and scanning started.
                    <b-form-checkbox class="mr-n2 mb-n1" v-model="status.agree1" @change="(x) => model.is_start = x && status.agree2 && status.agree3 && status.agree4 ">
                      I've checked, and I agree.
                    </b-form-checkbox>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center text-danger">
                    * Traffic is generated on the actual website
                    <b-form-checkbox class="mr-n2 mb-n1" v-model="status.agree2" @change="(x) => model.is_start = status.agree1 && x && status.agree3 && status.agree4 ">
                      I've checked, and I agree.
                    </b-form-checkbox>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center text-danger">

                    <a target="_blank" :href="redir" class="card-link">
                      <i class="fa fa-share"></i>
                      {{redir}}
                    </a>
                    <b-form-checkbox class="mr-n2 mb-n1" v-model="status.agree3" @change="(x) => model.is_start = status.agree1 && status.agree2 && x && status.agree4 ">
                      I've checked, and I agree.
                    </b-form-checkbox>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center text-danger">
                    <strong>Scheduling Everyday at AM {{status.interval}}</strong>
                    <b-form-checkbox class="mr-n2 mb-n1" v-model="status.agree4" @change="(x) => model.is_start = status.agree1 && status.agree2 && status.agree3 && x ">
                      I've checked, and I agree.
                    </b-form-checkbox>
                  </b-list-group-item>
                </b-list-group>
                <hr>
                <b-form-checkbox
                  class="mr-n2 mb-n1"
                  @change="(x) => { status.agree1 = x; status.agree2 = x; status.agree3 = x; status.agree4 = x }"
                  v-model="model.is_start"
                  ref="agreement"
                >
                  <strong>I've All checked, and I agree.</strong>
                </b-form-checkbox>
              </center>

            </b-form-group>
            <!-- final -->
            <b-form-group v-if="status.step == 3" v-bind:key="2">
              <center>
                <p>Complated Quick configure</p>
                <p>The inspection will begin shortly.</p>
                <p></p>
                <b-button variant="link" @click="go_site()" class="px-0">You can reset the site in detail </b-button>
                or
                <b-button variant="link" @click="go_policy()" class="px-0">modify the inspection policy </b-button>
              </center>
            </b-form-group>
          </transition-group>
        </b-col>
      </b-row>
      <hr>
      <!-- 마지막에는 이전이 없어야 함 -->
      <b-row>
        <b-col sm="12">
          <b-button v-if="status.step > 0 && status.step < steps.length - 1" block size="sm" variant="info" @click="prev()"> Prev </b-button>
          <b-button v-if="status.step < steps.length - 1"  block size="sm" variant="primary" @click="next()">Next </b-button>
          <!-- <b-button v-else  block size="sm" variant="success" @click="go_list">Complete</b-button> -->
        </b-col>
      </b-row>
    </b-card>
    <link rel="stylesheet" href="custom/wmds.site.quick.setup.css">
    <!-- delete modal -->
    <b-modal size="xl" title="Choice Policy"  class="modal-primary" v-model="modal_policy" @ok="modal_policy = false" header-bg-variant="primary" ok-variant="primary">
      <PolicyList :use_view="false" @selected="x => { policy = Object.assign({}, policy, x.policy); policy_description = x.description; modal_policy = false; policy_selected = true; status.policy_id = x.id }"/>
    </b-modal>
  </div>
</template>

<style lang="css">
/* 여기만 설명이 길어서 추가, 향후 전체 페이지 적용을 고려할 수 있음 */
.tooltip .tooltip-inner{
  max-width: 500px !important;
  width: 400px !important;
}
</style>
<script>
// 좋은 예제 설명 : https://mygumi.tistory.com/326
import { Switch as cSwitch } from '@coreui/vue';
import { Api } from '@/service';
import punycode from 'punycode';
import reg from '@/reg';
// import codes from '@/codes';
import _ from 'lodash';
// import the css (OPTIONAL - you can provide your own design)
import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';
import PolicyList from '../policy/Policy.List';

export default {
  props : ['is_first'],
  components: { cSwitch, StepProgress, PolicyList },
  filters: {},
  data : () => {
    return {
      show : false,
      // 새로운 변수
      steps : ['What is your FQDN(Domain) ?', 'Set Scanning Policy', 'Agreement on Terms of Use', 'Complete'],
      status : {
        agree1 : false,
        agree2 : false,
        agree3 : false,
        agree4 : false,
        step : 0,
        site_id : -1,
        policy_id : -1,
        interval : 3, // hour
      },
      model : { is_https : true, fqdn : '' },
      policy : { depth: 5, links: 20, limit: 50, timeout: 5, delay: 50 },
      policy_description : 'Quick Setup Policy Sample',
      policy_has : false,
      policy_selected : false,
      modal_policy : false
    }
  },
  computed : {
    redir() {
      // console.log(`${location.protocol}//${location.hostname == 'localhost' ? 'www.f1secaas.net' : location.hostname.replace('console.', 'www')}/ToS`)
      return `${location.protocol}//${location.hostname == 'localhost' ? 'www.f1secaas.net' : location.hostname.replace('console.', 'www.')}/ToS`
    }
  },
  methods: {
    // new
    async next(step = undefined) {
      try {
        if(step) { this.status.step = step }
        else {
          if(this.status.step == 0 && !this.model.fqdn) { this.$refs.fqdn.$el.focus(); return this.$toastr.e("require FQDN(domain)") }
          if(this.status.step == 0 && !this.check_fqdn(this.model.fqdn)) { this.$refs.fqdn.$el.focus(); return this.$toastr.e("FQDN(domain) is incorrect") }
          if(this.status.step == 2 && !this.model.is_start) { this.$refs.agreement.focus(); return this.$toastr.e("require Agreement on Terms of Use") }
          if(this.status.step == 2 && !await this.save()) { return this.$toastr.e("save failed") }

          this.status.step = this.status.step >= this.steps.length ? this.steps.length : this.status.step + 1
        }
      } catch (e) { console.log(e) }
    },
    prev(step = undefined) {
      if(step) { this.status.step = step }
      else { this.status.step = this.status.step <= 0 ? 1 : this.status.step - 1 }
    },

    // ui method
    check_fqdn(fqdn) {
      try {
        fqdn = _.trim(fqdn);
        if(!fqdn || !reg.domain.test(punycode.toASCII(fqdn))) { return false }
        if(reg.prevent_domain.test(punycode.toASCII(fqdn))) { return false }
        return true
      } catch (e) { console.error(e) }
    },
    go_list() { this.$router.push({ name : 'wmds_site'}); this.$emit('count', 2) },
    go_site() { this.$router.push({ name : 'wmds_site', params : { id : this.status.site_id }}); this.$emit('refresh') },
    go_policy() { this.$router.push({ name : 'wmds_policy', params : { id : this.status.policy_id }}); },
    async save() {
      if(!this.policy_selected)
      {
        try {
          // build policy info
          let rs = await Api.Manager_Call('wmds.policy', 'insert', Object.assign({}, { policy : this.policy, description : this.policy_description }));
          if(rs.error) { return false }
          this.status.policy_id = rs.body.id
          console.log('generate site done')
        } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText);  return false  }
      }

      try {
        // build site info
        let name = _.startsWith(this.model.fqdn, 'www.') ? this.model.fqdn.split('.')[1] : this.model.fqdn.split('.')[0];
        let site = { fqdn : this.model.fqdn,
          name : name,
          is_alive: true,
          is_cron: false,
          is_start: this.model.is_start,
          is_js: true,
          policy_id : this.status.policy_id,
          schedule: [`0 ${this.status.interval} * * *`], // 새벽 3시 자동 설정
          config: {
              seeds : [`${this.model.is_https ? 'https' : 'http'}://${this.model.fqdn}`],
              subs: [],
              prevents: []
            }
          }
        let rs = await Api.Manager_Call('wmds.site', 'insert', Object.assign({}, site));
        if(rs.error) { return false }
        this.status.site_id = rs.body.id
        console.log('generate site done')

        // 동의 기록
        try {
          let rs = await Api.Manager_Call('wmds.site', 'agree', { ts : new Date().getTime() });
          if(rs.error) { return this.$toastr.e("apply agreement failed") }
          // 시스템 로그가 남아야 함, 동의 부분 관련
        } catch (e) { console.log(e); this.$toastr.e("apply agreement failed") }

      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText); return false  }

      this.$toastr.s('Successful Saved');

      return true
    },

    async check_policy() {
      // this part change dynamic loding
      this.add = false;
      let so = {
        target : 'policy', cmd : 'list',
        body : { sort : [{name : 'id', op : 'desc'}], or : [], and : [{ name : "is_del", value : false, op : '='}] },
        limit : 1
      }
      let rs = await Api.Manager(so);
      if(rs.error) { return this.$toastr.e("load failed") }
      this.policy_has = (rs.body || []).length > 0
    },
  },
  watch: { '$route' (to, from) { console.log(from.path) } },
  created: function() { console.log('site.quick.setup.vue', 'created'); },
  destroyed: function() { console.log('site.quick.setup.vue', 'destroyed'); },
  mounted: function() {
    console.log('site.quick.setup.vue', 'mounted');
    this.check_policy()
  },
}
</script>
